// extracted by mini-css-extract-plugin
export default {"wrapper":"SideNav_wrapper__RiZOd","active":"SideNav_active__+kUEy","label":"SideNav_label__3Qz6u"};